;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('filterGroupsDropdown', filterGroupsDropdown)

  /* @ngInject */
  function filterGroupsDropdown () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        showFilterButton: '<',
        defaultGroupsList: '<',
        countGroups: '<'
      },
      templateUrl: '/core/directives/core-filters/dropdowns/filter-groups-dropdown/filter-groups-dropdown-directive.html?$$REVISION$$',
      controller: 'FilterGroupsDropdownController'
    }
  }
})()
